import { PageButtonSchema } from '@/views/sports/components/PageButton/styles/PageButton.styles';

export const pageButtonStyles: PageButtonSchema = {
  button: {
    variant: 'outline',
    fontSize: '2xs',
    height: 'auto',
    lineHeight: 'inherit',
    borderRadius: 'base',
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25),0px 3px 0px 0px #480,0px 1px 0px 0px rgba(255, 255, 255, 0.40) inset,0px 0px 0px 1px rgba(255, 255, 255, 0.20) inset',
    background:
      'linear-gradient(to bottom, var(--bc-colors-alpha-400), var(--bc-colors-alpha-500))',
    color: 'var(--bc-colors-alpha-800)',
    border: 'none',
    px: '3',
    py: '1',
    _hover: {
      bg: '#a2ff3e',
    },
    _active: {
      bg: 'beta.600',
      borderColor: 'transparent',
      boxShadow: 'inset 0 3px 3px 3px rgba(0, 0, 0, .3)',
      color: '#cc952b',
      textShadow: 'none',
      _after: { opacity: '0' },
    },
    sx: { '&:active, &[data-active:"true"]': {} },
  },
};
